import { DeliveryCards } from "@affinity/components/DeliveryCard";
import { CardGridContainer } from "@affinity/components/ProductList/ProductListCardGrid";
import { Section } from "@affinity/components/Section";
import { toDate } from "@affinity/constants/FormatHelpers";
import PlaceOrderSetPriceAndDeliveryOption from "@affinity/Handlers/PlaceOrderSetPriceAndDeliveryOption";
import { CustomState } from "@affinity/Store/Reducers";
import { AffinityDelivery } from "@affinity/Store/StoreTypes";
import Zone from "@insite/client-framework/Components/Zone";
import Typography from "@insite/mobius/Typography";
import React, {useEffect, useState} from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: CustomState) => ({
    // Map required state elements to component properties
    billToId: state.context.session.billToId!, // Should exist if user is logged in
    deliveryCheapest: state.affinity_place_order.deliveryCheapest,
    deliverySoonest: state.affinity_place_order.deliverySoonest,
    hasAttempted: state.affinity_place_order.hasAttemped
});

const mapDispatchToProps = {
    // Map loader and setter methods to component properties
    PlaceOrderSetPriceAndDeliveryOption,
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & { contentId: string };

export const Step4SelectPriceAndDeliveryOptions: React.FC<Props> = ({
    deliveryCheapest,
    deliverySoonest,
    billToId,
    hasAttempted,
    PlaceOrderSetPriceAndDeliveryOption,
    contentId,
}) => {

    const [fuelError, setFuelError] = useState("");

    useEffect(() => {
        if((typeof deliveryCheapest === "undefined" || typeof deliveryCheapest === "undefined") && hasAttempted){
            setFuelError("There was an error getting your price, please refresh and try again");
        }else{
            setFuelError("");
        }
    }, [deliveryCheapest, deliverySoonest, hasAttempted]);

    return (
        <Section title="4. Price and delivery options" shouldFocus={true}>
            <Typography variant="h3">Choose an option</Typography>
            <DeliveryCards 
                isLoading={false}
                deliveryCheapest={deliveryCheapest}
                onClickCheapest={() => {
                    PlaceOrderSetPriceAndDeliveryOption({ delivery: AffinityDelivery.Cheapest, billToId });
                }}
                onClickSoonest={() => {
                    PlaceOrderSetPriceAndDeliveryOption({ delivery: AffinityDelivery.Fastest, billToId });
                }}
                deliverySoonest={deliverySoonest}
                errorMessage={fuelError}
            />
            <Zone contentId={contentId} zoneName="PlaceOrderStep4" requireRows={false} />
        </Section>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Step4SelectPriceAndDeliveryOptions);
